import { render, staticRenderFns } from "./SagaShow.vue?vue&type=template&id=16997808&scoped=true&"
import script from "./SagaShow.vue?vue&type=script&lang=js&"
export * from "./SagaShow.vue?vue&type=script&lang=js&"
import style0 from "./SagaShow.vue?vue&type=style&index=0&id=16997808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16997808",
  null
  
)

export default component.exports